import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ReservationService } from "../services/reservation-service/reservation.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";

import { ActivatedRoute, Router } from "@angular/router";
import swal from "sweetalert2";
import { LeadsService } from "../services/lead-service/lead-service.service";
import { ProjectsService } from "../services/projects/projects.service";
import { UserServiceService } from "../services/user-service/user-service.service";
import { PaginationComponent } from "../layout/pagination/pagination.component";

@Component({
  selector: "app-fines-list",
  templateUrl: "./fines-list.component.html",
  styleUrls: ["./fines-list.component.css"],
})
export class FinesListComponent implements OnInit {
  @ViewChild("paginationRef") paginationRef: PaginationComponent;
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  pagination_meta = {
    page: 1,
    totalPages: 0,
  };
  fines_list: any;
  fines_rows_date: any;

  is_refreshing = false;
  filterForm: FormGroup;
  filterActive = false;
  filterData: any;

  projects;
  store_banks;
  banks;
  file: any;
  file_name: any;

  pagination: any = [];
  active_tab: any = "all";
  approveCollect: any = {
    collection_date: null,
    bank_id: null,
    cheque_number: null,
    transaction_number: null,
    store_status: null,
    partially_method: null,
  }

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private reservationService: ReservationService,
    private errorHandlerService: ErrorHandlerService,
    private projectsService: ProjectsService,
    private leadsService: LeadsService,
    private router: Router,
    private fb: FormBuilder,
    private userService: UserServiceService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.createFilter();
    if (
      ["filter_date_from", "filter_date_to"].some(
        (f) => this.route.snapshot.queryParams[f]
      )
    ) {
      this.filterForm.patchValue({
        filter_date_from: this.route.snapshot.queryParams["filter_date_from"],
        filter_date_to: this.route.snapshot.queryParams["filter_date_to"],
      });
    }
    this.getProjects();
    this.getStoreBanks();
    this.getBanks();
    this.getFines();
  }


  setActiveTab(tab) {
    this.active_tab = tab;
    let userId = "";
    switch (tab) {
      case "all": {
        this.filterForm.get("filter_status").setValue("");
        break;
      }
      case "pending-collection": {
        this.filterForm.get("filter_status").setValue("pending-collection");
        break;
      }
    }
    this.getFines();
  }

  getFines(reset = false, is_export = false) {
    if (reset) {
      this.pagination_meta.page = 1;
    }
    const payload = {
      ...this.filterForm.value,
      page: this.pagination_meta.page,
    };
    this.slimLoadingBarService.start();
    this.reservationService.getReservationFines(payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        this.fines_rows_date = res;
        this.fines_list = res.data;
        this.pagination_meta.totalPages = res.last_page;
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  getProjects() {
    this.reservationService.getProjects({ is_select_form: true }).subscribe(
      (res: any) => {
        this.projects = res;
      },
      (err) => console.log(err)
    );
  }

  getStoreBanks() {
    this.slimLoadingBarService.start();
    this.userService.getBanks().subscribe(
      (data: any) => {
        this.store_banks = [...data, { id: "null", name: "Blank" }];
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getBanks() {
    this.slimLoadingBarService.start();
    this.reservationService.getbanks().subscribe(
      (data: any) => {
        this.banks = [...data, { id: "null", name: "Blank" }];
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  createFilter() {
    this.filterForm = this.fb.group({
      filter_project_id: [""], // done
      // filter_status: [""], // done
      filter_lead: [""], // done
      filter_reservation: [""], // done
      filter_unit: [""], // done
      filter_status: [""], // done
      // filter_bank_id: [""], // done
      // types: [""],
      filter_cheque_number: [""], // done
      filter_transaction_number: [""], // done
      filter_date_from: [""], // done
      filter_date_to: [""], // done
      // filter_store_bank_id: [""],
      // filter_is_with_treasury: [""],
    });
  }

  resetFilters() {
    this.createFilter();
    this.getFines(true);
  }

  exportTable() {
    let formModel = Object.assign({}, this.filterForm.value);
    formModel.is_export = 1;
    this.slimLoadingBarService.start();
    this.reservationService
      .getReservationFines(formModel)
      .subscribe((data: any) => {
        window.open(data.url);
        this.slimLoadingBarService.complete();
      }),
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      };
  }

  pageChange(event) {
    this.pagination_meta.page = event;
    this.getFines();
  }

  // actions
  collect_fine: any;
  collect_form = {
    ids: [],
    collection_date: null,
    status: null,
    lead_id: null,
    partially_method: null,
    amount_received: null,
    partially_data: null,
    store_status: null,
  };

  openCollectFine(fine, modal) {
    this.collect_fine = fine;
    this.collect_form = {
      ids: [fine.id],
      collection_date: null,
      status: null,
      lead_id: null,
      partially_method: null,
      amount_received: null,
      partially_data: null,
      store_status: null,
    };
    modal.open();
  }

  collectFinesModalSubmitting = false;
  submitCollectFine(modal) {
    if (this.collectFinesModalSubmitting) return;
    let payload = Object.assign({}, this.collect_form);
    if(payload.partially_method == '3'){
      payload['file_name'] = this.file_name;
      payload['file'] = this.file;
    }

    if (this.collect_form.status == "partially-collected") {
      if (payload.partially_method != "3") {
        delete payload.partially_data;
      }
    } else {
      delete payload.amount_received;
    }

    this.collectFinesModalSubmitting = true;
    this.slimLoadingBarService.start();
    this.reservationService
      .collectChequeFine(this.collect_fine.reservation.id, payload)
      .subscribe(
        (res: any) => {
          swal("Woohoo!", "Collected!", "success");
          modal.close();
          this.getFines();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.collectFinesModalSubmitting = false;
      });
  }

  deleteFine(fine) {
    swal({
      title: "Are you sure?",
      text: "You will delete this fine!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        let payload = {
          ids: [fine.id],
        };
        this.slimLoadingBarService.start();
        this.reservationService
          .deleteReservationFine(this.collect_fine.reservation.id, payload)
          .subscribe(
            (res: any) => {
              swal("Success", "Deleted Fine successfully", "success");
              this.slimLoadingBarService.complete();
              this.getFines();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  /**
   * Start of import reservation modal
   */
  uploadExcelFile;

  importFinesModalOpen() {
    this.uploadExcelFile = null;
  }

  importFinesModalClose() {
    this.uploadExcelFile = null;
  }

  uploadExcelMethod(modal) {
    if (!this.uploadExcelFile) return;

    let data = {
      file_name: this.uploadExcelFile.file_name,
      file_value: this.uploadExcelFile.file_value,
    };

    this.slimLoadingBarService.start();
    this.reservationService.importFines(data).subscribe(
      (data) => {
        this.getFines();
        let inputValue = (<HTMLInputElement>document.getElementById("file"))
          .value;
        inputValue = "";
        modal.close();
        swal("Fines imported successfully", "", "success");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  handleUploadExcel(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.uploadExcelFile = {
          file_name: file.name,
          file_value: (reader.result as any).split(",")[1],
        };
      };
    }
  }

  onFileSelect(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.file_name = file.name;
        this.file = (reader.result as any).split(",")[1];
      };
    }
  }

  getNewRecord(event) {
    this.fines_rows_date = event;
    this.fines_list = event.data;
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  filter() {
    this.paginationRef.page = 1;
    this.paginationRef.infinite();
  }

  resetFilter() {
    this.createFilter();
    this.paginationRef.page = 1;
    this.paginationRef.resetFilters();
  }


  approveCollectFine(list) {
    swal({
      title: "Are you sure?",
      text: "You will Approve this fine!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        const payload = {
          ids: [list.id],
        };
        this.slimLoadingBarService.start();
        this.reservationService.approveCollectFine(payload).subscribe(
          (res: any) => {
            swal("Woohoo!", "Collected!", "success");
            this.getFines();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        );
      }
    });
  }

  rejectCollectFine(list) {
    swal({
      title: "Are you sure?",
      text: "You will Reject this fine!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        const payload = {
          ids: [list.id],
        };
        this.slimLoadingBarService.start();
        this.reservationService.rejectCollectFine(payload).subscribe(
          (res: any) => {
            swal("Woohoo!", "Collected!", "success");
            this.getFines();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          }
        );
      }
    });
  }


  assignApproveCollectChequeModal(payment) {
    this.approveCollect.bank_id = payment.bank_id;
    this.approveCollect.cheque_number = payment.cheque_number;
    this.approveCollect.transaction_number = payment.transaction_number;
    this.approveCollect.store_status = +payment.store_status;
    this.approveCollect.partially_method = payment.partially_method;
    this.approveCollect.collection_date = payment.collection_date;
    this.approveCollect.id = payment.id;
  }

  approvePendingCollect(modal) {
    const payload = {
      ...this.approveCollect,
      ids: [this.approveCollect.id],
    };
    if(this.approveCollect.partially_method != 4){
      delete payload.cheque_number;
    }else {
      delete payload.transaction_number;
      delete payload.store_status;
    }
    if (payload.partially_method == "4" && !payload.cheque_number) {
      swal("cheque number is required", "", "error");
      return;
    }
    if((payload.partially_method == "3" || payload.partially_method == "2") && !payload.transaction_number) {
      swal("transaction number is required", "", "error");
      return;
    }
    if((payload.partially_method == "3" || payload.partially_method == "2") && !payload.store_status) {
      swal("Location is required", "", "error");
      return;
    }
    if((payload.partially_method === '2' || payload.partially_method === '3' || payload.partially_method === '4') && !payload.bank_id) {
      swal("Customer Bank is required", "", "error");
      return;
    }
    if(!payload.collection_date) {
      swal("Collection Date is required", "", "error");
      return;
    }
    this.slimLoadingBarService.start();
    this.reservationService.approveCollectFine(payload).subscribe(
      (res: any) => {
        swal("Success", "Payment Approved Successfully!", "success");
        this.slimLoadingBarService.complete();
        this.getFines();
        modal.close();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/fines-list/fines-list.component.ts